/*
 * Creates a catalog
 *
 * Usage: catalogService.create('highway', highway)
 *          .then(=> ...)
 */
import Vue from 'vue'
import WarehouseTransformer
    from '../../../transformers/catalog/warehouse/warehouse'

export default (type, payload, options = {}) => {
  let transformed = WarehouseTransformer.send(payload)

  return Vue.$http.post('iwarehouse/create-with-highway/', transformed).then((response) => {
    const data = response.data
    transformed = WarehouseTransformer.fetch(data)
    const source = options.source

    if (source) {
      source.push(transformed)
    }
    return transformed
  })
}


// WEBPACK FOOTER //
// ./src/services/purchase/warehouse/create.js